export default 'coursepackage';